import { Handle } from '../Canvas';
import { SendEmailWorkflow } from '../Workflows/SendEmail/SendEmailWorkflow';

export const SendEmailMessageNode = ({ id }) => {
  return (
    <>
      <Handle type="target" position={'top' as any} />
      <SendEmailWorkflow id={id} />
      <Handle type="source" position={'bottom' as any} />
    </>
  );
};
